import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const ProgBrandBonaFidePctList = ({ progObj }) => {
  
  const augRowsReq = useCallback((rowsReq) => {
    if (!progObj) return;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('progId', progObj.id));
  }, [progObj]);


  return (
    <EntityList entity="PROG_BRAND_BONA_FIDE_PCT" augRowsReq={augRowsReq}/>
  )
}